import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid} from "@mui/material";
import {RiPencilLine,} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import {truncateString} from "../../../../../utils/utils";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleCopy?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleCopy = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "descricao",
    label: "Tema",
    align: "left",
    columnStyle: {
      overflowWrap: 'break-word',
      width: 300,
      wordBreak: 'break-word',
      whiteSpace: 'break-spaces'
    },
  },
  {
    id: "basico",
    label: "Básico",
    align: "left",
    customField: (text) => <p title={text}>{truncateString(text, 40)}</p>,
    columnStyle: {
      overflowWrap: 'break-word',
      width: 300,
      wordBreak: 'break-word',
      whiteSpace: 'break-spaces'
    },
  },
  {
    id: "intermediario",
    label: "Intermediário",
    align: "left",
    customField: (text) => <p title={text}>{truncateString(text, 40)}</p>,
    columnStyle: {
      overflowWrap: 'break-word',
      width: 300,
      wordBreak: 'break-word',
      whiteSpace: 'break-spaces'
    },
  },
  {
    id: "avancado",
    label: "Avançado",
    align: "left",
    customField: (text) => <p title={text}>{truncateString(text, 40)}</p>,
    columnStyle: {
      overflowWrap: 'break-word',
      width: 300,
      wordBreak: 'break-word',
      whiteSpace: 'break-spaces'
    },
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    sortable: false,
    width: 320,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <SETableIconButton onClick={() => handleEdit(row)}>
            <RiPencilLine size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
